// extracted by mini-css-extract-plugin
export var subtitle = "_cv-2";
export var title = "_cv-0";
export var titleNoWrap = "_cv-1";